import { memo } from "react";

import { ChartStatus, useChartsContext } from "contexts/ChartContext";
import { BoxPlotDisplayMode } from "entities/charts/boxPlotDisplayMode";
import { anyTrue } from "utils/fp";

import { useChartEntities } from "hooks/charts";

import ViolinPlot from "components/icons/ViolinPlot";

import ToolbarButton from "../../base/ToolbarButton";
import { useBoxPlotModeToggle } from "./useBoxPlotModeToggle";

const ViolinPlotToggle = () => {
  const { id, status } = useChartsContext();
  const { violinPlotToggle } = useChartEntities(id);
  const isActive = violinPlotToggle?.active;
  const showButton = violinPlotToggle?.show;
  // Switching mode while a response is in flight would seed the toggle against data that is
  // about to be replaced, so the button waits, the same way the lasso beside it does.
  const isDisabled = anyTrue(!violinPlotToggle?.enabled, status === ChartStatus.Loading);
  const toggle = useBoxPlotModeToggle(BoxPlotDisplayMode.Violin);

  if (!showButton) {
    return null;
  }

  return (
    <ToolbarButton
      data-testid="violin-plot-toggle"
      icon={<ViolinPlot />}
      active={isActive}
      overflowLabel="Show Violin Plots"
      tooltipText="Toggle Violin Plot"
      onToggle={toggle}
      disabled={isDisabled}
    />
  );
};

export default memo(ViolinPlotToggle);
